import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const navItems = [
    { path: '/', label: '地图拼图', icon: '🗺️', public: true },
    { path: '/listening', label: '英语听力', icon: '🎧', public: false }
  ];

  const handleNavClick = (item: typeof navItems[0]) => {
    if (item.public || user) {
      navigate(item.path);
    } else {
      // Redirect to login for protected routes
      navigate('/listening');
    }
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 mb-4">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-2">
              <span className="text-2xl">🌏</span>
              <span className="text-xl font-bold text-gray-900">学习中心</span>
            </Link>
            
            <div className="flex space-x-4">
              {navItems.map((item) => (
                <div key={item.path} className="relative">
                  <motion.div
                    onClick={() => handleNavClick(item)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 cursor-pointer ${
                      location.pathname === item.path
                        ? 'bg-blue-500 text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span className="mr-2">{item.icon}</span>
                    {item.label}
                  </motion.div>
                  
                  {location.pathname === item.path && (
                    <motion.div
                      className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500"
                      layoutId="activeTab"
                      initial={false}
                      transition={{ type: "spring", stiffness: 500, damping: 30 }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-3">
                <div className="text-sm">
                  <span className="text-gray-600">欢迎, </span>
                  <span className="font-medium">{user.name}</span>
                  <span className="ml-2 text-xs bg-green-100 text-green-600 px-2 py-1 rounded">
                    积分: {user.currentrewardtotal}
                  </span>
                </div>
                <button
                  onClick={logout}
                  className="text-sm text-gray-500 hover:text-gray-700 px-3 py-1 rounded border border-gray-300 hover:border-gray-400"
                >
                  退出
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-gray-500">未登录</span>
                <button
                  onClick={() => navigate('/listening')}
                  className="text-sm bg-blue-500 text-white hover:bg-blue-600 px-3 py-1 rounded transition-colors"
                >
                  登录
                </button>
              </div>
            )}
            
            <div className="text-sm text-gray-500">
              v2.5.2 - 多功能学习平台
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
